import { co2 } from './common';

export default {
  'consumption.co2': `${co2} emissions combined`,
  'consumption.energy': 'Power consumption in combined test cycle',
  'consumption.fuel': 'Fuel consumption combined',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Votre recherche/OnlineCode ',
  'search.result.buy-online': 'Buy Online',
  'search.results': 'Aucun résultat trouvé | {count} Résultat | {count} Résultats',
  'search.results.count': '{count} Résultats',
  'search.results.backup': "Nous n'avons pas trouvé résultats. Voir les pages similaires",
  'search.results.none.summary': "Aucun résultat n'a été trouvé. Veuillez réessayer avec un autre terme.",
  'search.show-more': 'Voir plus',
  'search.unavailable': 'La recherche est momentanément indisponible',
  'search.result.new': 'Nouveau',
  'input.placeholder': 'Votre recherche/OnlineCode',

  'suggestions.all_search_results': 'Tous les résultats de recherche',
  'suggestions.all_search_results_for': 'Afficher tous les résultats pour',
  'suggestions.in': 'dans',

  all: 'Tous',
  UCOS: "Boutique en ligne véhicules d'occasion",
  PASSENGER_CARS: 'VP',
  VANS: 'Vans',
  NCOS: 'Boutique en ligne véhicules neufs',
  VIDEO: 'Vidéos',
  DEALER_LOCATOR: 'Recherche de distributeur',
  CONFIGURATOR: 'Configurer votre véhicule',
  TEST_DRIVE: 'Essai sur route',
  VEHICLE_SEARCH: 'Recherche de véhicules d’occasion',
  COLLECT: 'Collection et accessoires',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Accessoires de voiture',

  'search.result.consumption': 'Consommation',
  'watch.video': 'Regarder la vidéo',
  'input.recently': 'Récemment recherché',
  'input.help.title': 'Regarder la vidéo?',
  'input.help.text':
    "Rechercher par types de véhicules, modèles, codes de configuration ou rechercher des accessoires, d'autres produits et informations",

  'search.result.grid': 'Grille',
  'search.result.list': 'Liste',

  // No results
  'support.check': "Veuillez vérifier l'orthographe ou essayer avec un autre terme.",
  'support.no.results': "Aucun résultat n'est disponible pour ce terme recherché.",
  'support.no.results.term': 'Aucun résultat trouvé',
  'support.chat': 'Vous ne trouvez pas ce que vous cherchez ?Veuillez utiliser notre assistance en',
  'support.chat.with.us': 'ligne ou par messagerie instantanée.',

  'search.results.offer': 'Offres populaires pour "{query}":',
};
